module.exports = __webpack_public_path__ + "img/相关新闻@2x.f65c642f.png";